var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgenticAiCompaniesHowToEvaluateOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1376 768",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Nine questions for evaluating an agentic AI company",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1376,
    height: 768,
    fill: "#1D162A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Outfit, Poppins, 'Segoe UI', Helvetica, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 110,
    fontSize: 15,
    fontWeight: 600,
    fill: "#B47CFD",
    textAnchor: "start",
    letterSpacing: 2.4,
    opacity: 1
  }, "EVALUATING AGENTIC AI COMPANIES"), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 164,
    fontSize: 34,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Nine questions. Listen for the ones they haven&#x27;t thought about."), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 210,
    width: 376,
    height: 120,
    rx: 14,
    fill: "#261A35",
    stroke: "#3A2B4E",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 246,
    r: 18,
    fill: "#B47CFD",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 252,
    fontSize: 16,
    fontWeight: 800,
    fill: "#1D162A",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "1"), /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 252,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "How will you evaluate it,"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 284,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "and against what?"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 314,
    fontSize: 11,
    fontWeight: 700,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 1.5,
    opacity: 1
  }, "EVALUATION"), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 210,
    width: 376,
    height: 120,
    rx: 14,
    fill: "#261A35",
    stroke: "#3A2B4E",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 246,
    r: 18,
    fill: "#B47CFD",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 252,
    fontSize: 16,
    fontWeight: 800,
    fill: "#1D162A",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "2"), /*#__PURE__*/React.createElement("text", {
    x: 562,
    y: 252,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "What can the agent do"), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 284,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "\u2014 and not do?"), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 314,
    fontSize: 11,
    fontWeight: 700,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 1.5,
    opacity: 1
  }, "PERMISSIONS"), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 210,
    width: 376,
    height: 120,
    rx: 14,
    fill: "#261A35",
    stroke: "#3A2B4E",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 246,
    r: 18,
    fill: "#B47CFD",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 930,
    y: 252,
    fontSize: 16,
    fontWeight: 800,
    fill: "#1D162A",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "3"), /*#__PURE__*/React.createElement("text", {
    x: 962,
    y: 252,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Where does a human take"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 284,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "over?"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 314,
    fontSize: 11,
    fontWeight: 700,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 1.5,
    opacity: 1
  }, "HANDOFF"), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 346,
    width: 376,
    height: 120,
    rx: 14,
    fill: "#261A35",
    stroke: "#3A2B4E",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 382,
    r: 18,
    fill: "#B47CFD",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 388,
    fontSize: 16,
    fontWeight: 800,
    fill: "#1D162A",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "4"), /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 388,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "What is logged per run?"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 420,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 450,
    fontSize: 11,
    fontWeight: 700,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 1.5,
    opacity: 1
  }, "OBSERVABILITY"), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 346,
    width: 376,
    height: 120,
    rx: 14,
    fill: "#261A35",
    stroke: "#3A2B4E",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 382,
    r: 18,
    fill: "#B47CFD",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 388,
    fontSize: 16,
    fontWeight: 800,
    fill: "#1D162A",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "5"), /*#__PURE__*/React.createElement("text", {
    x: 562,
    y: 388,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "What happens when the model"), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 420,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "version changes?"), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 450,
    fontSize: 11,
    fontWeight: 700,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 1.5,
    opacity: 1
  }, "DRIFT"), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 346,
    width: 376,
    height: 120,
    rx: 14,
    fill: "#261A35",
    stroke: "#3A2B4E",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 382,
    r: 18,
    fill: "#B47CFD",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 930,
    y: 388,
    fontSize: 16,
    fontWeight: 800,
    fill: "#1D162A",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "6"), /*#__PURE__*/React.createElement("text", {
    x: 962,
    y: 388,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "What will inference cost at"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 420,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "our volume?"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 450,
    fontSize: 11,
    fontWeight: 700,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 1.5,
    opacity: 1
  }, "COST"), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 482,
    width: 376,
    height: 120,
    rx: 14,
    fill: "#261A35",
    stroke: "#3A2B4E",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 518,
    r: 18,
    fill: "#B47CFD",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 524,
    fontSize: 16,
    fontWeight: 800,
    fill: "#1D162A",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "7"), /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 524,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Who owns the repo, cloud"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 556,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "and prompts?"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 586,
    fontSize: 11,
    fontWeight: 700,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 1.5,
    opacity: 1
  }, "OWNERSHIP"), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 482,
    width: 376,
    height: 120,
    rx: 14,
    fill: "#261A35",
    stroke: "#3A2B4E",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 518,
    r: 18,
    fill: "#B47CFD",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 524,
    fontSize: 16,
    fontWeight: 800,
    fill: "#1D162A",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "8"), /*#__PURE__*/React.createElement("text", {
    x: 562,
    y: 524,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Is the price fixed against"), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 556,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "written scope?"), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 586,
    fontSize: 11,
    fontWeight: 700,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 1.5,
    opacity: 1
  }, "COMMERCIAL"), /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 482,
    width: 376,
    height: 120,
    rx: 14,
    fill: "#261A35",
    stroke: "#3A2B4E",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 518,
    r: 18,
    fill: "#B47CFD",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 930,
    y: 524,
    fontSize: 16,
    fontWeight: 800,
    fill: "#1D162A",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "9"), /*#__PURE__*/React.createElement("text", {
    x: 962,
    y: 524,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Give me a reference I"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 556,
    fontSize: 15,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "can phone."), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 586,
    fontSize: 11,
    fontWeight: 700,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 1.5,
    opacity: 1
  }, "PROOF"), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 660,
    fontSize: 15,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Focused agent $9.5k\u201322k \xB7 Multi-step with retrieval $22k\u201356k \xB7 Enterprise, private hosting, above that."), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 712,
    fontSize: 16,
    fontWeight: 600,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 3,
    opacity: 1
  }, "WORKFLOX"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenticAiCompaniesHowToEvaluateOne);
export default __webpack_public_path__ + "static/media/agentic-ai-companies-how-to-evaluate-one.c13752f9c721a9f14ff53cd330ca181b.svg";
export { ForwardRef as ReactComponent };